import { Platform } from "react-native";

import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    contactAgentList: {
      marginTop: theme.margin.cs,
    },
    yourAgenInfo: {
      width: "50%",
      marginRight: theme.margin.md,
      display: "none",
      "@media (min-width: 700px)": {
        display: "flex",
      },
    },
    headingText: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontSize: theme.fontsize.xxl2,
      maxHeight: 60,
      position: "relative",
      top: theme.spacing.md,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    bodyText: {
      width: 400,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.cs,
      position: "relative",
      top: 28,
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    graphicArea: {
      ...Platform.select({
        ios: {
          "@media (min-width: 700px)": {
            // iPad mini
            top: 150,
            left: 0,
          },
        },
        android: {
          "@media (min-width: 700px)": {
            // iPad mini
            top: 150,
            left: 0,
          },
        },
      }),
    },
    agentImage: {
      width: 400,
      height: 450,
      marginTop: 120,
    },
    contactAgent: {
      position: "absolute",
      left: -50,
      top: -236,
      ...Platform.select({
        ios: {
          "@media (min-width: 700px)": {
            width: 500,
            height: 525,
          },
          "@media (min-width: 1100px)": {
            width: 600,
            height: 625,
          },
        },
        android: {
          "@media (min-width: 700px)": {
            left: -60,
            width: 500,
            height: 525,
          },
          "@media (min-width: 1100px)": {
            width: 600,
            height: 625,
          },
        },
      }),
    },
    contactInfo: {
      width: "100%",
      "@media (min-width: 700px)": {
        width: "40%",
        position: "absolute",
        top: 10,
        right: 0,
      },
      "@media (min-width: 1000px)": {
        width: "40%",
        position: "absolute",
        top: 0,
      },
    },
    contactMyAgentHeading: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      marginBottom: theme.margin.md,
    },
    textLarge: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontSize: Platform.OS == "ios" ? theme.fontsize.lg : theme.fontsize.md,
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "right",
      color: theme.colors.white,

      marginBottom: theme.margin.sm,
    },
    textMedium: {
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.md,
      letterSpacing: 0,
      textAlign: "center",
      color: theme.colors.white,
      marginBottom: theme.margin.sm,
    },
    textSmall: {
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.md,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
      marginBottom: theme.margin.sm,
    },
    contactAgentDetail: {
      zIndex: theme.zIndex.min,
      display: "flex",
      flexDirection: "row",
    },
  },
  web: {
    contactAgentList: {
      marginTop: theme.margin.cs,
    },
    headingText: {
      lineHeight: 1,
      fontSize: theme.fontsize.xxl2,
      position: "relative",
      top: theme.margin.lg,
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,

      textTransform: "uppercase",
    },
    bodyText: {
      width: 400,
      fontSize: theme.fontsize.cs,
      fontFamily: theme.fontFamily.robotoRegular,
      fontWeight: theme.fontweight.light,
      position: "relative",
      top: theme.margin.xxl5,
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,
    },
    yourAgenInfo: {
      width: "50%",
      marginRight: theme.margin.md,
      display: "none",
      "@media (min-width: 700px)": {
        display: "flex",
      },
    },
    graphicArea: {
      fontWeight: theme.fontweight.medium,
      top: 130,
    },
    agentImage: {
      width: 400,
      height: 400,
      marginTop: 120,
    },
    contactAgent: {
      position: "absolute",
      left: -60,
      top: -236,
      "@media (min-width: 700px)": {
        transform: [{ scale: ".8" }],
        top: -240,
        left: -30,
        width: 450,
        height: 475,
      },
      "@media (min-width: 1150px)": {
        transform: [{ scale: ".9" }],
        top: -250,
        width: 600,
        height: 625,
      },
      "@media (min-width: 1281px)": {
        transform: [{ scale: ".95" }],
        top: -236,
      },
      "@media (min-width: 1441px)": {
        transform: [{ scale: ".95" }],
        top: -236,
      },
      "@media (min-width: 1681px)": {
        transform: [{ scale: ".95" }],
        top: -236,
      },
    },
    contactInfo: {
      width: "100%",
      "@media (min-width: 700px)": {
        width: "40%",
        position: "absolute",
        top: 10,
        right: 0,
      },
      "@media (min-width: 1000px)": {
        width: "40%",
        position: "absolute",
        top: 0,
      },
    },
    contactMyAgentHeading: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      marginBottom: theme.margin.md,
    },
    textLarge: {
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      fontSize: theme.fontsize.lg,
      textAlign: "right",
      color: theme.colors.white,

      marginBottom: theme.margin.sm,
    },
    textMedium: {
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.mmd,
      textAlign: "left",
      color: theme.colors.white,
      marginBottom: theme.margin.ssm,
    },
    textSmall: {
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.cs,

      textAlign: "left",
      color: theme.colors.white,
      marginBottom: theme.margin.sm,
      fontWeight: theme.fontweight.xlight,
    },

    contactAgentDetail: {
      zIndex: theme.zIndex.min,
      display: "flex",
      flexDirection: "row",
    },
  },
});
